import React from "react";

const LogoutConfirmModal = ({ show, onHide, onConfirm }) => {
  return (
    <>
      {show && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          aria-hidden={!show}
        >
          <div className="bg-white rounded-lg shadow-lg w-11/12 max-w-xl mx-auto flex flex-col">
            {/* Modal Header */}
            <div className="flex justify-between items-center p-4 border-b sticky top-0 bg-[#ECF6FF] z-10">
              {/* Title */}
              <h2 className="text-16 font-bold text-gray-700">Logout</h2>

              {/* Close Button */}
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={onHide}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Scrollable Content */}
            <div
              className="container mx-auto p-5 overflow-y-auto flex-grow"
              style={{ maxHeight: "60vh" }}
            >
              <h3 className="text-center m-3 font-semibold">
                Are you sure?
              </h3>
              <h6 className="text-center m-3">
                Are you sure you want to logout your account?
              </h6>
            </div>

            {/* Modal Footer */}
            <div className="flex justify-center gap-4 p-4 border-t sticky bottom-0 bg-gray-100 z-25">
              <button
                className="px-4 py-2 text-12 bg-gray-300 text-gray-800 rounded hover:bg-gray-400"
                onClick={onHide}
              >
                No
              </button>
              <button
                className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                onClick={() => {
                  onConfirm();
                  onHide();
                }}
              >
                YES
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LogoutConfirmModal;
